import React from "react";
import TwoDrilldownTable from "../../../Components/Table/TqpDrillldownTable";

const Columns = [
  {
    id: "region",
    header: "Region",
    accessorFn: (value) => value.Region,
    cell: (info) => (
      <span className="text-center  w-20" title="Click to view Statewise WSR ">
        {info?.getValue()}
      </span>
    ),
    size: 200,
  },

  {
    header: "Target MTD",
    accessorFn: (value) => value.TQP_Target_MTD,
    cell: ({ row }) => (
      <span className="text-right">{row?.original.TQP_Target_MTD}</span>
    ),
  },
  {
    header: "Actual MTD",
    accessorFn: (value) => value.TQP_Actual_MTD,
    cell: ({ row }) => (
      <span className="text-right">{row?.original.TQP_Actual_MTD}</span>
    ),
  },
  {
    header: "MTD (%)",
    accessorFn: (value) => value.TQP_MTD,
    cell: ({ row }) => (
      <span className="text-right">{row?.original.TQP_MTD}</span>
    ),
  },
  {
    header: "Velocity (%)",
    accessorFn: (value) => value.TQP_VELOCITY,
    cell: ({ row }) => (
      <span className="text-right">{row?.original.TQP_VELOCITY}</span>
    ),
  },
  {
    header: "C3 MTD Target",
    accessorFn: (value) => value.C3_MTD_Target,
    cell: ({ row }) => (
      <span className="text-right">{row?.original.C3_MTD_Target}</span>
    ),
  },
  {
    header: "C3 MTD Retail",
    accessorFn: (value) => value.C3_MTD_Retail,
    cell: ({ row }) => (
      <span className="text-right ">{row?.original.C3_MTD_Retail}</span>
    ),
  },
];
const WsrTqp = () => {
  const endpoint = "wsr/";
  return (
    <div>
      <TwoDrilldownTable
        QueryKey="wsr-tqp"
        heading="Region/Dealer Wise TQP"
        columns={Columns}
        endpoint={endpoint}
        className={""}
      />
    </div>
  );
};

export default WsrTqp;
